import { useNavigator } from '@repo/toolkit/use-navigator'
import { useEffect } from 'react'

import LoadingScreen from '../../components/elements/loading/loading-screen'
import { Paths } from '../../lib/constants/path'
import useAuth from '../../lib/hooks/use-auth'

export function LogoutPage() {
  const { logout } = useAuth()
  const { navigate } = useNavigator()

  async function handleLogout() {
    await logout()
    navigate(Paths.AUTH_LOGIN_PAGE)
  }

  useEffect(() => {
    handleLogout()
  }, [])

  return <LoadingScreen />
}
